import { Map } from 'immutable'
import { createSelector } from 'reselect'

const getSessionState = (state: Map<string, any>) => state?.get('session')

export const getSessionId = createSelector(getSessionState, (session) => session?.get('sessionId'))
